import { TransformFn } from "objectro/lib/types";
import { get } from "../../utils/helpers";

export const transformPostalAddressToInternalAddress: TransformFn = (
  value: any
) => {
  return {
    streetAddress1: get(value, "streetAddress1", null),
    streetAddress2: get(value, "streetAddress2", null),
    addressLocality: get(value, "city", null),
    addressRegion: get(value, "region", null),
    postalCode: get(value, "postalCode", null),
    addressCountry: get(value, "country")
  };
};

// Map the DDC Backend Customer object to the customerDataState
// DDCCustomer -> customerFormState
export const fromDDCCustomer = {
  identifier: "identifier",
  gender: "gender",
  title: "honorificPrefix",
  firstName: "givenName",
  alternateFirstName1: "alternateGivenName1",
  lastName: "familyName",
  alternateLastName1: "alternateFamilyName1",
  birthDate: "birthDate",
  email: "email",
  homePhoneNumber: "telephone",
  mobilePhoneNumber: "mobileTelephone",
  // This won't be mapped to a nested object within the customer data object
  // The internal data model requires a shallow object
  address: transformPostalAddressToInternalAddress,
  appsConsent: "appsConsent",
  emailConsent: "emailConsent",
  postConsent: "postConsent",
  phoneConsent: "phoneConsent",
  advisorCode: "salesPerson",
  // special tiffany fields
  barcode: "barcode",
  middleName: "middleName",
  maritalStatus: "maritalStatus",
  profession: "profession",
  weddingDate: "weddingDate",
  confirmConsent: "confirmConsent"
};
